import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";

const AgriMIS = () => {
  const [datelist, setDatelist] = useState([]);

  const FillDetail = () => {
    const Datelst = [
      { name: "Farmers Enrollment", reportUrl: "/agriFarmersEnrollmentTemplate", icon: "fa-user-plus" },
      { name: "Field Demonstration", reportUrl: "/agriPromoterReport", icon: "fa-seedling" },
      { name: "Field Days Indicator", reportUrl: "/fieldDaysIndicator", icon: "fa-calendar-check" },
      { name: "Training MOV", reportUrl: "/trainingMOV", icon: "fa-chalkboard-teacher" },
      { name: "Sales KPI", reportUrl: "/salesKPI", icon: "fa-chart-line" },
      { name: "Field Demonstration Target", reportUrl: "/fieldDemonstrationTargetReport", icon: "fa-bullseye" },
      { name: "Field Days Attendance", reportUrl: "/fieldDaysAttendance", icon: "fa-users" },
      { name: "Training KPI", reportUrl: "/trainingKPI", icon: "fa-user-graduate" },
      { name: "Market Intelligence(Product)", reportUrl: "/marketIntelligenceGatheringReport", icon: "fa-lightbulb" },
      { name: "Market Intelligence(Crop)", reportUrl: "/marketIntelligenceCorpReport", icon: "fa-chart-pie" },
      { name: "Field Indicator Details", reportUrl: "/fieldIndicatorDetails", icon: "fa-info-circle" },
      { name: "Product Sales Target V/s Actual", reportUrl: "/agriPoromoterProductSales", icon: "fa-tachometer-alt" },
      { name: "Agri Farmer Inspection Report", reportUrl: "/agriFarmerInspectionReport", icon: "fa-clipboard-check" },
      { name: "Agri Crop Cut Report", reportUrl: "/agriCropCutReport", icon: "fa-cut" },
      { name: "Hub Sales Report", reportUrl: "/hubSalesReport", icon: "fa-store" },
      { name: "Hub Inventory Summary", reportUrl: "/hubinventorysummary", icon: "fa-boxes" },
    ];
    setDatelist(Datelst);
  };

  useEffect(() => {
    FillDetail();
  }, []);

  const colors = [
    "#4caf50", "#ff9800", "#e91e63", "#9c27b0", "#2196f3",
    "#795548", "#03a9f4", "#8bc34a", "#f44336", "#607d8b",
    "#673ab7", "#009688", "#ff5722", "#3f51b5", "#00bcd4",
    "#c2185b"
  ];

  return (
    <div className="content-wrapper p-4">
      <h4 className="mb-4 text-primary">📋 Agri Promoter Report Dashboard</h4>

      <div className="row">
        {datelist.map((item, index) => (
          <div className="col-md-4 mb-3" key={index}>
            <Link to={item.reportUrl} className="text-decoration-none">
              <div
                className="report-box d-flex align-items-center shadow-sm p-3 rounded"
                style={{
                  borderLeft: `10px solid ${colors[index % colors.length]}`,
                  backgroundColor: "#fff",
                }}
              >
                <div
                  className="icon-circle d-flex justify-content-center align-items-center mr-3"
                  style={{
                    backgroundColor: colors[index % colors.length],
                    color: "white",
                  }}
                >
                  <i className={`fas ${item.icon}`} />
                </div>
                <div className="report-name text-dark font-weight-bold">{item.name}</div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      <style>{`
        .report-box {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-radius: 12px;
        }
        .report-box:hover {
          transform: translateY(-4px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        }
        .icon-circle {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          font-size: 18px;
          flex-shrink: 0;
        }
        .report-name {
          font-size: 15px;
          line-height: 1.3;
        }
      `}</style>
    </div>
  );
};

export default AgriMIS;
